<template>
  <!-- 报名成功 -->
  <div class="title-huikuan">
    <div class="sign_su" style="height:auto;line-height: 25px;">
      <p>预报名成功！本次报名为预报名，请您及时联系部门负责人，并汇款到指定账号，汇款成功后与您所在部门负责人联系，进行订单核实</p>
  </div>
    <div class="sign_s">
      <h5 v-if="huikuan.length > 0">汇款信息:</h5>
      <div class="hui-title" v-html="huikuan"> </div>
      <van-row class="sign_two">
        <router-link class="more-link" :to="{ name: 'OrderDetails', params: { order_no: order_no }}">
          <van-col span="12" class="order" style="color:#fd882b">查看订单</van-col>
        </router-link>
        <router-link to="/">
          <van-col span="12" style="color:#fd882b">去首页</van-col>
        </router-link>
      </van-row>
    </div>

  </div>
</template>

<script>
  import {
    formatDates,
    formatWeekDate
  } from "../../assets/js/date";
  export default {
    data() {
      return {
        order_no: '',
        data: [] ,
        huikuan:''
      };
    },
    /* 时间过滤 */
    filters: {
      formatDates, //调用方法formatTime(1575346406, 'Y年M月D日 h:m:s')
      formatWeekDate //
    },
    created: function() {
      var _this = this;
      _this.order_no = _this.$route.params.order_no;
      _this.$WXConfig.wxShowMenu({
        ifshare: true,
        that: _this,
        data: ''
      });
      var xianxia = sessionStorage.getItem('hy_xianxia_' + _this.order_no);
      if (xianxia === 'offline') {
        _this.xxtishi = true;
        sessionStorage.removeItem('hy_xianxia_' + _this.order_no)
      }
      _this.onLoad();
    },
    methods: {
      //待完善人员列表
      onLoad() {
        var _this = this;
        let url = "/ac1/conference/orderDetail";
        let params = {
          order_no:_this.order_no
        };
        _this.$get(url, params).then(res => {
          if (res.code == "1") {
            _this.huikuan = res.posts.conference.conference.remittance_info;
          }
        });
      },
    }
  };
</script>

<style lang="less" scoped>
  .title-huikuan {
    width: 100%;
    min-height: 100vh;
    background: #f7f7f7;
    font-size: 28px;

    .sign_s {
      font-size: 30px;
      min-height: 80vh;
      background-color: white;
      padding: 30px 30px;
      letter-spacing: 3px;
      h5{
        font-size: 30px;
        color: #333;
        font-weight: 600;
      }
      .sign_one {
        text-align: center;
        font-weight: 600;

        img {
          display: inline-block;
          width: 103px;
          height: 103px;
          margin-bottom: 28px;
        }

        p {
          margin-bottom: 30px;
        }

        .tishi {
          min-height: 20px;
          margin-bottom: 30px;
          padding: 5px 20px;
        }
      }
      .hui-title{
        width: 100%;
        padding: 30px 30px 50px;
        font-size: 26px;
        line-height: 45px;
        min-height: 35vh;
      }
      .sign_two {
        width: 523px;
        height: 88px;
        line-height: 88px;
        padding: 0 20px;
        text-align: center;
        border: 1px solid #fd882b;
        color: #fd882b;
        margin: auto;
        border-radius: 100px;
        text-align: center;

        .order,
        .fapiao {
          position: relative;
        }

        .order::after {
          content: "";
          height: 60px;
          width: 2px;
          position: absolute;
          right: 0;
          top: 14px;
          background: linear-gradient(to top, #f2f2f2, #fd882b, #eaeaea);
        }

        .fapiao::after {
          content: "";
          height: 60px;
          width: 2px;
          position: absolute;
          right: 0;
          top: 14px;
          background: linear-gradient(to top, #f2f2f2, #fd882b, #eaeaea);
        }
      }
    }

    .sign_su {
      width: 100%;
      height: 80px;
      background-color: #f4f8ff;
      line-height: 80px;
      font-size: 26px;
      color: #2b68da;
      padding: 0px 30px;
    }
  }
</style>
